import api from '@pray/shared/utils/api';

export type RetryAllLeadValidationResponse = {
  data: {
    artists_count: number;
    total_pending: number;
    status: 'initiated';
    message?: string;
  };
};

export async function retryAllLeadValidation(): Promise<RetryAllLeadValidationResponse> {
  const url = '/web/studio/system-check/lead-validation/retry-all';
  // Same double-unwrap pattern as the GET path: HTTP body wraps in `{ data }`
  // and the serializer payload is itself `{ data: { ... } }`.
  const response = await api.executePostRequest<{ data: RetryAllLeadValidationResponse }>(url);

  return response.data.data;
}
